import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Card, CardBody, Col } from 'reactstrap';

const FilterHeader = ({
  filter, callback, headerTitle,
}) => (
  <Col md={12} xl={12} lg={12} xs={12}>
    {/* <Card className="pb-3">
      <CardBody className="card-shadow p-3"> */}
        <div className="card__title mb-2">
          <h5 className="bold-text card__title-center">{headerTitle}</h5>
        </div>
        <div className="filter-Wrapper">
          <div className="form form--justify">
            {filter && filter.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data, key) => {
              const options = [];
              data.filterData.forEach((element) => {
                options.push({ label: element.shortValue, value: element.key });
              });

              const sorted = options.sort((a, b) => a.label > b.label ? 1 : -1)
              return (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={key}>
                  <div className="form__form-group mb-1">
                    <span className="form__form-group-label">{data.filterName}</span>
                    <div className="form__form-group-field">
                      <Select
                        options={sorted}
                        clearable={false}
                        className="select_filter"
                        isMulti
                        onChange={val => callback(val, data.applyToColumn)}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                </React.Fragment>
              );
            })}
          </div>

        </div>
      {/* </CardBody>
    </Card> */}
  </Col>
);



FilterHeader.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  callback: PropTypes.func.isRequired,
  headerTitle: PropTypes.string.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(FilterHeader);
